/* tslint:disable */
/* eslint-disable */
/**
 * care-plan
 * care-plan
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InformationalCarePlanInfoListItem } from './InformationalCarePlanInfoListItem';
import {
    InformationalCarePlanInfoListItemFromJSON,
    InformationalCarePlanInfoListItemFromJSONTyped,
    InformationalCarePlanInfoListItemToJSON,
} from './InformationalCarePlanInfoListItem';

/**
 * 
 * @export
 * @interface FindAllInformationalCPE200Response
 */
export interface FindAllInformationalCPE200Response {
    /**
     * 
     * @type {Array<InformationalCarePlanInfoListItem>}
     * @memberof FindAllInformationalCPE200Response
     */
    data?: Array<InformationalCarePlanInfoListItem>;
}

/**
 * Check if a given object implements the FindAllInformationalCPE200Response interface.
 */
export function instanceOfFindAllInformationalCPE200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllInformationalCPE200ResponseFromJSON(json: any): FindAllInformationalCPE200Response {
    return FindAllInformationalCPE200ResponseFromJSONTyped(json, false);
}

export function FindAllInformationalCPE200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllInformationalCPE200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(InformationalCarePlanInfoListItemFromJSON)),
    };
}

export function FindAllInformationalCPE200ResponseToJSON(value?: FindAllInformationalCPE200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(InformationalCarePlanInfoListItemToJSON)),
    };
}

